import React from 'react';
import { useEffect } from "react";
import Accordion from 'react-bootstrap/Accordion';
import Sticky from 'react-sticky-el';
import { useMediaQuery } from 'react-responsive';


const TableOfContent= () => {

  const isLg = useMediaQuery({ query: '(max-width: 991px)' });

    useEffect(() => {
      setTimeout(() => {
          const headlines = document.querySelectorAll('.contentclass .block-type-heading');
          const headlinesArr = Array.apply(null, headlines);
          const headlinesUl = document.getElementById('listBlocks');
          // const listTitle = document.getElementById("listBlocksTitle");
          // const listButton = document.getElementById("listBlocksTitleBtn");
          // const listIco = document.getElementById("listBlocksIcon");
          for (let i = 0; i < headlines.length; i++) {
            const headlineId = headlines[i].id;
            const headlineText = headlines[i].textContent;
            let listViewItem = document.createElement('div');
            let listViewItemLink = document.createElement('a');
            headlinesUl.appendChild(listViewItem);
            listViewItem.appendChild(listViewItemLink);
            listViewItemLink.href = '#' + headlineId;
            listViewItemLink.insertAdjacentText("afterbegin", headlineText);
          }
      }, 1000);
    },[]);
    


  return (
    <Sticky>
    <Accordion defaultActiveKey={isLg ? '' : '0'} flush className="bg-positive toc">
      <Accordion.Item eventKey="0" className="bg-transparent">
        <Accordion.Header className="fw-bold">Inhaltsverzeichnis</Accordion.Header>
        <Accordion.Body id="listBlocks">
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
    </Sticky>
  );
}

export default TableOfContent;